import api, { request } from '../../../api';
import { IStore } from '../../index';

const deleteRoundTee = async (
  _: IStore,
  clubId: number,
  eventId: number,
  roundId: number,
  teeAssignationId: number
) => {
  const response = await request.delete(api.roundTee(clubId, eventId, roundId, teeAssignationId));

  return !!!response.error;
};

export default deleteRoundTee;
